import React, { Component } from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';
interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
}
export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }
  static getDerivedStateFromError(error: Error): Partial<State> {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('❌ Error Boundary caught:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }
  handleReload = () => {
    window.location.reload();
  };
  handleGoHome = () => {
    window.location.href = '/';
  };
  render() {
    if (this.state.hasError) {
      return <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-id="element-426">
          <div className="max-w-2xl w-full bg-white rounded-2xl shadow-xl p-8" data-id="element-427">
            <div className="text-center mb-6" data-id="element-428">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-red-100 rounded-full mb-4" data-id="element-429">
                <AlertTriangle className="w-10 h-10 text-red-600" data-id="element-430" />
              </div>

              <h1 className="text-3xl font-bold text-slate-900 mb-2" data-id="element-431">
                Oeps! Er ging iets mis
              </h1>

              <p className="text-slate-600 mb-6" data-id="element-432">
                De app heeft een onverwachte fout tegengekomen. Probeer de
                pagina opnieuw te laden.
              </p>

              <div className="flex gap-3 justify-center" data-id="element-433">
                <button onClick={this.handleReload} className="inline-flex items-center gap-2 px-6 py-3 bg-indigo-600 text-white rounded-xl font-medium hover:bg-indigo-700 transition-colors" data-id="element-434">
                  <RefreshCw className="w-5 h-5" data-id="element-435" />
                  Pagina herladen
                </button>
                <button onClick={this.handleGoHome} className="inline-flex items-center gap-2 px-6 py-3 bg-slate-200 text-slate-700 rounded-xl font-medium hover:bg-slate-300 transition-colors" data-id="element-436">
                  <Home className="w-5 h-5" data-id="element-437" />
                  Naar home
                </button>
              </div>
            </div>

            {this.state.error && <details className="mt-6" data-id="element-438">
                <summary className="cursor-pointer text-sm text-slate-500 hover:text-slate-700 mb-2 font-medium" data-id="element-439">
                  Technische details (voor ontwikkelaars)
                </summary>
                <div className="bg-slate-900 text-white p-4 rounded-lg text-xs font-mono overflow-auto max-h-64" data-id="element-440">
                  <div className="mb-2 text-red-400 font-bold" data-id="element-441">
                    {this.state.error.toString()}
                  </div>
                  {this.state.errorInfo && <pre className="text-slate-300 whitespace-pre-wrap" data-id="element-442">
                      {this.state.errorInfo.componentStack}
                    </pre>}
                </div>
              </details>}
          </div>
        </div>;
    }
    return this.props.children;
  }
}